import React from 'react';

export interface FileDropOverlayProps {
  /**
   * Whether the drag overlay should be visible
   */
  visible: boolean;
  /**
   * Primary message to display
   */
  message?: string;
  /**
   * Secondary message (hint text)
   */
  hint?: string;
  /**
   * Optional className for the overlay container
   */
  className?: string;
}

/**
 * Reusable drag-and-drop overlay component for file uploads.
 * Displays a visual indicator when dragging files over a drop zone.
 */
export function FileDropOverlay({ visible, message = 'Drop files here', hint, className }: FileDropOverlayProps) {
  if (!visible) {
    return null;
  }

  return (
    <div
      role="region"
      aria-label="Drop zone for files"
      className={`absolute inset-0 z-50 flex items-center justify-center border-2 border-dashed border-primary bg-background/80 backdrop-blur-sm ${className || ''}`}
    >
      <div className="text-center">
        <p className="text-lg font-medium text-foreground">{message}</p>
        {hint && <p className="text-sm text-muted-foreground">{hint}</p>}
      </div>
    </div>
  );
}
